import baseUrl from "../config/baseUrl";

const getProcessedTodayUserCount = async ({ token }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/get-processed-today-user-count-dashboard`,
      {
        method: "GET",

        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getProcessedTodayUserCount;
